import { render, staticRenderFns } from "./FinalReportValues.vue?vue&type=template&id=225ef21e&scoped=true&"
import script from "./FinalReportValues.vue?vue&type=script&lang=js&"
export * from "./FinalReportValues.vue?vue&type=script&lang=js&"
import style0 from "./FinalReportValues.vue?vue&type=style&index=0&id=225ef21e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225ef21e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
